// extracted by mini-css-extract-plugin
export var icon = "_9g-3";
export var subtitle = "_9g-2";
export var title = "_9g-1";
export var value = "_9g-0";